{
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% хэмнэнэ)",
    "{amount} days free": "{amount} өдөр үнэгүй",
    "{amount} off": "{amount} хямдрал",
    "{amount} off for first {number} months.": "Эхний {number} сард {amount} хямдралтай.",
    "{amount} off for first {period}.": "Эхний {period}-д {amount} хямдралтай.",
    "{amount} off forever.": "Үүрд {amount} хямдралтай.",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% хямдрал",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} хаяг руу {newsletterName} товхимол цаашид ирэхгүй болно.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} хаяг руу таны сэтгэгдэлд хариу бичихэд имэйл ирэхгүй болно.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} хаяг руу энэ товхимол цаашид ирэхгүй болно.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} өдөр үнэгүй",
    "{years} years": "",
    "+1 (123) 456-7890": "+976 1234-5678",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Бүртгэл",
    "Account details updated successfully": "Бүртгэлийн мэдээлэл амжилттай шинэчлэгдлээ",
    "Account settings": "Бүртгэлийн тохиргоо",
    "Add a personal note": "Хувийн тэмдэглэл нэмэх",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Үнэгүй туршилтын хугацаа дуусахад таны данснаас сонгосон багцын үнэ хасагдана. Гэхдээ та өмнө нь цуцлах боломжтой.",
    "Already a member?": "Бүртгэлтэй юу?",
    "An error occurred": "Алдаа гарлаа",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Алдаа гарлаа. Дахин оролдоно уу эсвэл энэхүү алдаа нь давтагдаж байвал <a>тусламж хүснэ үү</a>.",
    "Back": "Буцах",
    "Back to Log in": "Нэвтрэх хэсэг рүү буцах",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Хар Баасан Гариг Хямдрал",
    "Bluesky": "",
    "Cancel anytime.": "Хэзээ ч цуцлах боломжтой.",
    "Cancel subscription": "Захиалгаа цуцлах",
    "Canceled": "",
    "Cancellation reason": "Цуцалсан шалтгаан",
    "Change": "Өөрчлөх",
    "Change plan": "Багцаа өөрчлөх",
    "Check spam & promotions folders": "Спам ба промоушн хавтсаа шалгана уу",
    "Check with your mail provider": "Имэйл үйлчилгээ үзүүлэгчтэйгээ холбогдоно уу",
    "Check your inbox to verify email update": "Имэйл шинэчлэлтээ баталгаажуулахын тулд инбоксоо шалгана уу",
    "Choose": "Сонгох",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Өөр багц сонгох",
    "Choose a plan": "Багц сонгох",
    "Choose a tier": "",
    "Choose your newsletters": "Товхимолоо сонгох",
    "Click here to retry": "Дахин оролдохын тулд энд дарна уу",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Хаах",
    "Code": "",
    "Comment preferences updated.": "Сэтгэгдлийн тохиргоо шинэчлэгдлээ.",
    "Comments": "Сэтгэгдлүүд",
    "Complimentary": "Үнэгүй",
    "Confirm": "Баталгаажуулах",
    "Confirm cancellation": "Цуцлалтыг баталгаажуулах",
    "Confirm subscription": "Захиалгыг баталгаажуулах",
    "Contact support": "Дэмжлэгтэй холбогдох",
    "Continue": "Үргэлжлүүлэх",
    "Continue subscription": "Захиалгыг үргэлжлүүлэх",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Stripe төлбөрийн хэсгийг үүсгэж чадсангүй",
    "Could not sign in. Login link expired.": "Нэвтэрч чадсангүй. Нэвтрэх холбоосны хугацаа дууссан.",
    "Could not update email! Invalid link.": "Имэйлийг шинэчлэх боломжгүй! Буруу холбоос.",
    "Create a new contact": "Шинэ харилцагч үүсгэх",
    "Current plan": "Одоогийн багц",
    "Delete account": "Бүртгэлээ устгах",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Үүнийг хийхийг хүсээгүй юу? Тохиргоогоо <button>энд</button> удирдана уу.",
    "Don't have an account?": "Бүртгэлгүй юу?",
    "Edit": "Засах",
    "Email": "Имэйл",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Имэйл товхимол",
    "Email newsletter settings updated": "Имэйл товхимолын тохиргоо шинэчлэгдлээ",
    "Email preferences": "Имэйлийн тохиргоо",
    "Email preferences updated.": "Имэйлийн тохиргоо шинэчлэгдлээ.",
    "Emails": "Имэйлүүд",
    "Emails disabled": "Имэйл идэвхгүй болсон",
    "Ends {offerEndDate}": "{offerEndDate} дуусна",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Имэйл хаягаа оруулна уу",
    "Enter your name": "Нэрээ оруулна уу",
    "Error": "Алдаа",
    "Expires {expiryDate}": "{expiryDate} дуусна",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Захиалгыг цуцлаж чадсангүй, дахин оролдоно уу",
    "Failed to log in, please try again": "Нэвтэрч чадсангүй, дахин оролдоно уу",
    "Failed to log out, please try again": "Гарч чадсангүй, дахин оролдоно уу",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Төлбөр хийж чадсангүй, дахин оролдоно уу",
    "Failed to send magic link email": "Шидэт холбоос илгээж чадсангүй",
    "Failed to send verification email": "Баталгаажуулах имэйл илгээж чадсангүй",
    "Failed to sign up, please try again": "Бүртгүүлж чадсангүй, дахин оролдоно уу",
    "Failed to update account data": "Бүртгэлийн мэдээллийг шинэчилж чадсангүй",
    "Failed to update account details": "Бүртгэлийн дэлгэрэнгүй мэдээллийг шинэчилж чадсангүй",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Товхимолын тохиргоог шинэчилж чадсангүй",
    "Failed to update subscription, please try again": "Захиалгыг шинэчилж чадсангүй, дахин оролдоно уу",
    "Failed to verify code, please try again": "",
    "Forever": "Үүрд",
    "Free Trial – Ends {trialEnd}": "Үнэгүй туршилт – {trialEnd} дуусна",
    "From": "",
    "Get help": "Тусламж авах",
    "Get in touch for help": "Тусламж авахаар холбогдох",
    "Get notified when someone replies to your comment": "Хэн нэгэн таны сэтгэгдэлд хариу бичих үед мэдэгдэх",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Энэ нийтлэлд санал өгөх",
    "Help! I'm not receiving emails": "Тусламж! Би имэйл хүлээж авахгүй байна",
    "Here are a few other sites you may enjoy.": "Танд таалагдаж магадгүй бусад сайтууд.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Хэрвээ товхимолыг спам гэж тэмдэглэсэн бол тухайн хаягаас хүсээгүй имэйл ирэхгүй байхын тулд автоматаар имэйл илгээхийг идэвхгүй болгодог.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Хэрвээ спам гэсэн мэдэгдэл санаандгүй байсан, эсвэл та дахин имэйл хүлээн авч эхлэхийг хүсэж байгаа бол өмнөх дэлгэц дээрх товчлуурыг дарж имэйлд дахин бүртгүүлж болно.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Хэрвээ та одоо захиалгаа цуцалбал {periodEnd} хүртэл хандах эрхтэй хэвээр байна.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Хэрвээ танд корпорацийн эсвэл төрийн имэйл хаяг байгаа бол ИТ хэлтэстэйгээ холбогдоод {senderEmail}-с имэйл хүлээн авахыг зөвшөөрөхийг хүсээрэй.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Таны имэйл рүү нэвтрэх холбоосыг илгээлээ. Хэрвээ 3 минутын дотор ирэхгүй бол спамаа шалгана уу.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Хэрвээ та дахин имэйл хүлээн авч эхлэхийг хүсэж байгаа бол бүртгэлтэй имэйл хаягаа шалгаад, дараа нь өмнөх дэлгэцээс дахин бүртгүүлэх товчийг дарна уу.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Хэрвээ та захиалсан имэйл товхимолоо хүлээж авахгүй байгаа бол дараах зүйлсийг шалгана уу.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Хэрвээ та эдгээр бүгдийг шалгасны дараа ч имэйл хүлээж авахгүй байвал {supportAddress}-д хандаж дэмжлэг авна уу.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Хэрвээ товхимолыг илгээхэд байнгын алдаа гарвал тухайн бүртгэлийн имэйл идэвхгүй болгогдоно.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Имэйл програмдаа {senderEmail}-г харилцагчийн жагсаалтандаа нэмнэ. Энэ нь таны имэйл үйлчилгээ үзүүлэгчид энэ хаягаас илгээсэн имэйлүүдийг итгэмжтэй гэж үзэхэд тусална.",
    "Invalid email address": "Буруу имэйл хаяг",
    "Invalid verification code": "",
    "Jamie Larson": "Доржийн Бат",
    "jamie@example.com": "bat@example.com",
    "Less like this": "Таалагдсангүй",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Имэйлүүд таны Спам эсвэл Промоушн хавтсанд орохгүй байгаа эсэхийг шалгана уу. Хэрэв тийм бол \"Спам биш гэж тэмдэглэх\" эсвэл \"Инбокс руу зөөх\" гэсэн сонголтыг хийнэ үү.",
    "Manage": "Удирдах",
    "Maybe later": "Магадгүй дараа",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Энэхүү имэйл домэйнээс гишүүнчлэл авах нь хязгаарлагдсан байна.",
    "Memberships unavailable, contact the owner for access.": "Гишүүнчлэл боломжгүй байна, хандах эрх авахын тулд эзэмшигчтэй холбогдоно уу.",
    "month": "сар",
    "Monthly": "Сарын",
    "More like this": "Үүнтэй төстэй",
    "More options": "",
    "Name": "Нэр",
    "Need more help? Contact support": "Тусламж хэрэгтэй юу? Лавлахтай холбогдоно уу",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Таны бүртгэл дээрх товхимолууд хоёр шалтгаанаар идэвхгүй болсон байж болно: Өмнөх имэйлийг спам гэж тэмдэглэсэн, эсвэл имэйлийг илгээх оролдлого байнгын алдаа (баунс) гаргасан.",
    "No member exists with this e-mail address.": "Энэ имэйл хаягтай гишүүн байхгүй байна.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Имэйл ирээгүй юу?",
    "Now": "",
    "Now check your email!": "Одоо имэйлээ шалгана уу!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Дахин бүртгүүлсний дараа, хэрэв та имэйлүүдийг инбоксдоо харахгүй байвал спам хавтсаа шалгана уу. Зарим имэйл үйлчилгээ үзүүлэгчид өмнөх спам тэмдэглэгээнүүдийг хадгалдаг бөгөөд имэйлүүдийг тэмдэглэсээр байна. Хэрэв ийм байдал үүсвэл, сүүлийн үеийн товхимолыг 'Спам биш' гэж тэмдэглэж үндсэн инбокс руугаа буцааж зөөнө үү.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Байнгын алдаа (баунс)",
    "Phone number": "Утасны дугаар",
    "Plan": "Багц",
    "Plan checkout was cancelled.": "Багцын төлбөр цуцлагдлаа.",
    "Plan upgrade was cancelled.": "Багцын шинэчлэлт цуцлагдлаа.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Үнэгүй захиалгаа тохируулахын тулд {supportAddress}-д хандана уу.",
    "Please enter {fieldName}": "{fieldName} оруулна уу",
    "Please fill in required fields": "Шаардлагатай талбаруудыг бөглөнө үү",
    "Podcasts": "",
    "Re-enable emails": "Имэйлийг дахин идэвхжүүлэх",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Санал болгох",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price}-д шинэчлэгдэнэ.",
    "Resume subscription": "",
    "Retry": "Дахин оролдох",
    "Save": "Хадгалах",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Нэвтрэх холбоосыг илгээж байна...",
    "Sending...": "Илгээж байна...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Бүгдийг харуулах",
    "Sign in": "Нэвтрэх",
    "Sign out": "Гарах",
    "Sign up": "Бүртгүүлэх",
    "Signup error: Invalid link": "Бүртгүүлэх алдаа: Буруу холбоос",
    "Signups from this email domain are currently restricted.": "Энэхүү имэйл домэйнээс бүртгүүлэх нь хязгаарлагдсан байна.",
    "Something went wrong, please try again later.": "Ямар нэг алдаа гарлаа, дараа дахин оролдоно уу.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Уучлаарай, одоогоор санал болгох зүйл алга байна.",
    "Sorry, that didn’t work.": "Уучлаарай, амжилтгүй боллоо.",
    "Spam complaints": "Спамын гомдлууд",
    "Start {amount}-day free trial": "{amount} өдрийн үнэгүй туршилтыг эхлүүлэх",
    "Starting {startDate}": "{startDate}-с эхэлнэ",
    "Starting today": "Өнөөдрөөс эхэлнэ",
    "Submit feedback": "Саналаа илгээх",
    "Subscribe": "Захиалах",
    "Subscribed": "Захиалсан",
    "Subscription plan updated successfully": "Захиалгын багц амжилттай шинэчлэгдлээ",
    "Success": "Амжилттай",
    "Success! Check your email for magic link to sign-in.": "Амжилттай! Нэвтрэх шидэт холбоосыг имэйлээсээ шалгана уу.",
    "Success! Your account is fully activated, you now have access to all content.": "Амжилттай! Таны бүртгэл бүрэн идэвхжлээ, та одоо бүх контентод хандах эрхтэй боллоо.",
    "Success! Your email is updated.": "Амжилттай! Таны имэйл шинэчлэгдлээ.",
    "Successfully unsubscribed": "Захиалгыг амжилттай цуцаллаа",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Захиалга өгсөнд баярлалаа. Унших хуудсаа эхлэхээс өмнө доор танд таалагдаж магадгүй хэдэн сайтуудыг санал болгож байна.",
    "Thank you for your support": "Дэмжлэг үзүүлсэнд баярлалаа",
    "Thank you for your support!": "Дэмжлэг үзүүлсэнд баярлалаа!",
    "Thanks for the feedback!": "Саналаа илгээсэнд баярлалаа!",
    "That didn't go to plan": "Төлөвлөгөөний дагуу болсонгүй",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Бидэнд байгаа таны имэйл хаяг бол {memberEmail} — хэрэв энэ буруу бол <button>бүртгэлийн тохиргоо</button> хэсэгт шинэчилж болно.",
    "There was a problem submitting your feedback. Please try again a little later.": "Таны саналыг хүлээн авахад асуудал гарлаа. Дараа дахин оролдоно уу.",
    "There was an error cancelling your subscription, please try again.": "Таны захиалгыг цуцлахад алдаа гарлаа, дахин оролдоно уу.",
    "There was an error continuing your subscription, please try again.": "Таны захиалгыг үргэлжлүүлэхэд алдаа гарлаа, дахин оролдоно уу.",
    "There was an error processing your payment. Please try again.": "Таны төлбөрийг боловсруулахад алдаа гарлаа. Дахин оролдоно уу.",
    "There was an error sending the email, please try again": "Имэйл илгээхэд алдаа гарлаа, дахин оролдоно уу",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Энэхүү сайт руу зөвхөн урилгаар нэвтрэх боломжтой тул та админд нь хандана уу.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Энэхүү сайт одоогоор төлбөр хүлээн авахгүй байна.",
    "This site only accepts paid members.": "Энэхүү сайт зөвхөн төлбөртэй гишүүдийг хүлээн авдаг.",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Тан руу илгээсэн баталгаажуулах холбоос дээр дарж бүртгэлээ дуусгана уу. Хэрвээ 3 минутын дотор ирэхгүй бол спамаа шалгана уу!",
    "To continue to stay up to date, subscribe to {publication} below.": "Мэдээллээ шинээр авахын тулд доорх {publication}-д захиалга өгнө үү.",
    "Too many attempts try again in {number} days.": "Хэт олон оролдлого хийсэн тул {number} өдрийн дараа дахин оролдоно уу.",
    "Too many attempts try again in {number} hours.": "Хэт олон оролдлого хийсэн тул {number} цагийн дараа дахин оролдоно уу.",
    "Too many attempts try again in {number} minutes.": "Хэт олон оролдлого хийсэн тул {number} минутын дараа дахин оролдоно уу.",
    "Too many different sign-in attempts, try again in {number} days": "Хэт олон ялгаатай нэвтрэх оролдлого хийсэн тул {number} өдрийн дараа дахин оролдоно уу",
    "Too many different sign-in attempts, try again in {number} hours": "Хэт олон ялгаатай нэвтрэх оролдлого хийсэн тул {number} цагийн дараа дахин оролдоно уу",
    "Too many different sign-in attempts, try again in {number} minutes": "Хэт олон ялгаатай нэвтрэх оролдлого хийсэн тул {number} минутын дараа дахин оролдоно уу",
    "Too many sign-up attempts, try again later": "Хэт олон бүртгүүлэх оролдлого хийсэн тул дараа дахин оролдоно уу",
    "Try free for {amount} days, then {originalPrice}.": "{amount} өдөр үнэгүй турших, дараа нь {originalPrice}.",
    "Unable to initiate checkout session": "Төлбөрийн хэсгийг эхлүүлэх боломжгүй",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Төлбөртэй захиалагч болж бүх товхимолд хандах эрх авна уу.",
    "Unsubscribe from all emails": "Бүх имэйлийг зогсоох",
    "Unsubscribed": "Захиалга цуцлагдлаа",
    "Unsubscribed from all emails.": "Бүх имэйлийн захиалга цуцлагдлаа.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Имэйлийг зогсоосон ч таны {title} төлбөртэй захиалга цуцлагдахгүй",
    "Update": "Шинэчлэх",
    "Update your preferences": "Тохиргоогоо шинэчлэх",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Баталгаажуулах холбоос илгээгдлээ, шуудангаа шалгана уу",
    "Verify your email address is correct": "Имэйл хаягаа зөв эсэхийг шалгана уу",
    "Verifying...": "",
    "View plans": "Багцуудыг харах",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Энэхүү имэйл хаяг олдоогүй учир захиалгыг цуцлах боломжгүй. Та сайтын админд хандана уу.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Дахин тавтай морил, {name}!",
    "Welcome back!": "Дахин тавтай морил!",
    "Welcome to {siteTitle}": "{siteTitle}-д тавтай морил",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Инбокс имэйл хүлээн авч чадахгүй үед түүнийг баунс гэж нэрлэдэг. Ихэнх тохиолдолд энэ нь түр зуурын байж болно. Гэвч заримдаа, имэйл хаяг хүчингүй эсвэл байхгүй үед буцаагдсан имэйл нь байнгын алдаа болж чадна.",
    "Why has my email been disabled?": "Яагаад миний имэйл идэвхгүй болсон бэ?",
    "X (Twitter)": "",
    "year": "жил",
    "Yearly": "Жилийн",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Та одоогоор үнэгүй гишүүнчлэлтэй байна, бүрэн эрхтэй болохын тулд төлбөртэй захиалга руу шинэчилнэ үү.",
    "You have been successfully resubscribed": "Таны захиалга амжилттай дахин идэвхжлээ",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Та одоогоор имэйл хүлээж авах тохиргоогүй байна",
    "You're not receiving emails": "Та имэйл хүлээж тохиргоогүй байна",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Таны имэйл хүлээж авахгүй байгаа шалтгаан нь нэг бол та аль нэг имэйлийг спам гэж тэмдэглэсэн, эсвэл таны хаяг имэйл хүлээж авах боломжгүй байна.",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Та амжилттай нэвтэрлээ.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Таны захиалга амжилттай үүслээ. <strong>{siteTitle}</strong>",
    "Your account": "Таны бүртгэл",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Таны имэйлийг дахин захиалахад алдаа гарлаа, дахин оролдоно уу",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Таны санал дараа дараагийн нийтлэлийг илүү чанартай болгоход туслана",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Таны захиалга {expiryDate}-нд дуусна",
    "Your subscription will renew on {renewalDate}": "Таны захиалга {renewalDate}-нд шинэчлэгдэнэ",
    "Your subscription will start on {subscriptionStart}": "Таны захиалга {subscriptionStart}-нд эхэлнэ"
}
